export const LINE_DUPLICATE_COUNT = 5;
export const LINE_SEGMENTATION_COUNT = 15;
export const FACTOR_MULTIPLIER = -0.5;
export const DISTORT_RADIUS = 200;
export const SMOOTH_EXPONANT = 3;
export const CURSOR_ROTATE_RADIUS = 0;
export const CURSOR_ROTATE_SPEED = 0;
